import { render, staticRenderFns } from "./HouseholdFrame.vue?vue&type=template&id=4a6dc70c&scoped=true"
import script from "./HouseholdFrame.vue?vue&type=script&lang=js"
export * from "./HouseholdFrame.vue?vue&type=script&lang=js"
import style0 from "./HouseholdFrame.vue?vue&type=style&index=0&id=4a6dc70c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6dc70c",
  null
  
)

export default component.exports